import { Injectable, Injector } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { WorkOrderDocumentDialogComponent } from './work-order-document-dialog.component';

const defaults = {
    title: '',
    message: '',
    alert: '',
    height: '500px',
    width: '600px',
    closeLabel: 'Close',
    disableClose: true,
    onClosed: null
};

@Injectable()
export class WorkOrderDocumentDialogService {
    dialogRef: MatDialogRef<WorkOrderDocumentDialogComponent>;
    dialog: MatDialog;

    constructor(private readonly injector: Injector) {
        this.dialog = injector.get(MatDialog);
    }

    public openDialog(moduleName, workOrderId) {
        const options = {
            ...defaults
        };

        this.dialogRef = this.dialog.open(WorkOrderDocumentDialogComponent, options);
        this.dialogRef.componentInstance.moduleName = moduleName;
        this.dialogRef.componentInstance.workOrderId = workOrderId;
        return this.dialogRef;
    }

    public closeDialog() {
        this.dialogRef.close();
    }

}

